<div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
        [updateStatusType]="updateStatusType" [headerTemplate]="headerTemplate" [(isBusy)]="isBusy"
        [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
        [gridContext]="gridContext" [responseArrayCallback]="responseArrayCallback"
        [responseCallback]="responseCallback" [contextMenuOptions]="contextMenuOptions"
        [cellClickedCallback]="cellClickedCallback" [pagerTemplate]="pagerTemplate"
        [hasContextMenuPermissions]="hasContextMenuPermissions">
    </res-generic-grid>
    <ng-template #headerTemplate>
        <div class='parent-header'>
            <span>Projects</span>
        </div>
    </ng-template>
    <ng-template #pagerTemplate>
        <button class="download-button" (click)="download()"
            [attr.data-automation-id]="automationId + '-download-button'"
            [attr.title]="'Download the complete project manifest (.csv)'">
            <i class="fa fa-download"></i>
        </button>
    </ng-template>

</div>
<a download #downloadLink hidden></a>